export var BadgeMode;
(function (BadgeMode) {
    BadgeMode["Success"] = "success";
    BadgeMode["Warning"] = "warning";
    BadgeMode["Danger"] = "danger";
    BadgeMode["Info"] = "info";
    BadgeMode["Positive"] = "positive";
    BadgeMode["Negative"] = "negative";
    BadgeMode["BackgroundAlt"] = "background-alt";
    BadgeMode["BackgroundDefault"] = "background-default";
})(BadgeMode || (BadgeMode = {}));
export var BadgeCssClass;
(function (BadgeCssClass) {
    BadgeCssClass["Base"] = "iress-badge";
    BadgeCssClass["Badge"] = "iress-badge__badge";
    BadgeCssClass["HasHost"] = "iress-badge--host";
    BadgeCssClass["Pill"] = "iress-badge--pill";
})(BadgeCssClass || (BadgeCssClass = {}));
export var BadgeSlot;
(function (BadgeSlot) {
    BadgeSlot["Host"] = "host";
})(BadgeSlot || (BadgeSlot = {}));
//# sourceMappingURL=badge.types.js.map